var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import Heading from '@marketing/components/global/typography/Heading';
import { useMediaQuery } from '@mui/material';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import ImageTile from '../ImageTile';
function ProductTile(_a) {
    var image = _a.image, label = _a.label, _b = _a.fullbleed, fullbleed = _b === void 0 ? false : _b, _c = _a.fontColor, fontColor = _c === void 0 ? 'shoe' : _c, _d = _a.useHoverOverlay, useHoverOverlay = _d === void 0 ? false : _d, className = _a.className, _e = _a.backgroundVariant, backgroundVariant = _e === void 0 ? 'white' : _e, onResize = _a.onResize;
    var isMobile = useMediaQuery('(max-width: 768px)');
    var headingSize = isMobile ? 'xs' : 'sm';
    var _f = useState(null), calculatedTileWidth = _f[0], setCalculatedTileWidth = _f[1];
    var textContainerRef = null;
    useEffect(function () {
        onResize === null || onResize === void 0 ? void 0 : onResize(calculatedTileWidth);
    }, [calculatedTileWidth]);
    var twMerge = useTWMergeContext().twMerge;
    useEffect(function () {
        if (textContainerRef) {
            setCalculatedTileWidth(textContainerRef.clientWidth);
        }
        var handleResize = function () {
            if (textContainerRef) {
                setCalculatedTileWidth(textContainerRef.clientWidth);
            }
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // these are the values at full viewport width, but the tiles scale linearly
    // with their parent container, so we use these values in ratios to update
    // the font size and padding dynamically, since there is no way in CSS to do this
    var initialTilePadding = 12;
    var initialTileWidth = 216;
    var initialFontHeight = 36;
    var productNameTokens = label.split(' ');
    var productNameFirstLine = productNameTokens.slice(0, productNameTokens.length - 1).join(' ');
    var productNameSecondLine = productNameTokens[productNameTokens.length - 1];
    var imageSizeClassName = fullbleed ? 'w-full h-full' : 'w-[68%] h-[61.7%]';
    var backgroundColor = backgroundVariant === 'beige' ? 'surface-beige' : 'surface-white';
    return (_jsx(ImageTile, __assign({ image: image, outline: true, useHoverOverlay: useHoverOverlay, imageMargin: fullbleed ? 0 : (12 / 216) * calculatedTileWidth, backgroundColor: clsx(backgroundColor, !useHoverOverlay ? 'md:hover:bg-state-hover-squash-website' : ''), className: twMerge('w-[140px] h-[146px] md:h-auto md:w-auto md:max-w-[216px] md:max-h-[225px] md:aspect-[216/225]', className), imageStyles: clsx(imageSizeClassName) }, { children: _jsx("div", __assign({ 
            // need to use a callback ref here to ensure we can update the parent when the ref first
            // mounts. (Using a useRef/React.createRef doesn't trigger an update on mount.)
            ref: function (el) {
                if (el !== null) {
                    if (!textContainerRef) {
                        textContainerRef = el;
                    }
                    setCalculatedTileWidth(el.clientWidth);
                }
            }, className: "flex flex-col justify-end px-sm-button py-xs-button md:py-sm-button w-full h-full", style: {
                padding: "".concat((initialTilePadding / initialTileWidth) * calculatedTileWidth || initialTileWidth, "px"),
                fontSize: "".concat((initialFontHeight / initialTileWidth) * calculatedTileWidth || initialTileWidth, "px"),
            } }, { children: _jsxs("div", { children: [_jsx(Heading, __assign({ size: headingSize, className: "text-".concat(fontColor, " ![font-size:inherit] uppercase whitespace-nowrap") }, { children: productNameFirstLine })), _jsx(Heading, __assign({ size: headingSize, className: "text-".concat(fontColor, " ![font-size:inherit] uppercase") }, { children: productNameSecondLine }))] }) })) })));
}
export default ProductTile;
